/* somnair-cart.js — interactions du drawer « clone réf » (cf. somnair-cart.css).
   Deux contrôles, tous deux rendus en Liquid par des blocs custom_liquid du
   Cart drawer (donc re-rendus avec l'état frais du panier à chaque repaint) :

   1) [data-smc-up]   CTA « X MONTH SUBSCRIPTION SAVES Y% » : remplace la ligne
      One-Time par la variante « Subscribe & Save » du MÊME pack.
      En DEUX requêtes : /cart/add (nouvelle variante) puis /cart/change
      (quantity 0 sur la clé de l'ancienne ligne). Un seul /cart/update ne
      suffit PAS : `updates` ne sait que modifier des lignes déjà au panier,
      il n'ajoute jamais une variante absente (vérifié en live : la ligne
      One-Time partait sans que la Subscribe & Save arrive).
   2) [data-smc-prot] switch « Priority Shipping & Protection » : ajoute (3,99 $)
      ou retire la ligne. PRÉ-COCHÉE (opt-out) par défaut depuis le 20/10
      (PROT_PRECHECK), après un passage DÉCOCHÉE du 15/10 au 20/10 (demande de
      Zeid ; cf. plus bas pour le risque UK reg. 40 / FTC, assumé explicitement
      sans garde géographique). Avant ça, déjà PRÉ-COCHÉE du 18/08 au 15/10 :
      autoProtect()
      pose la ligne dès que la rangée apparaît décochée, le client décoche s'il
      n'en veut pas, et son refus tient pour l'onglet (cf. bas de fichier).
      Le titre parle de priorité
      de TRAITEMENT, pas de transport : le tarif transporteur se choisit au
      checkout et aucune ligne de panier ne peut le changer (cf.
      DOG_BOWL_BUILD.md §4 quater).
   0) [data-smc-swap] carte « Upgrade & Save » : remplace le palier B1G1 d'une
      gamelle chien par son B2G2 (ajout puis retrait par numéro de ligne).
   3) [data-smc-xs]   carte cross-sell du funnel chien : ajoute le modèle
      jumeau (Feeding Bowl <-> Feeder with Stands) au palier « Buy 1, get 1
      FREE ». Une seule requête /cart/add : on ajoute, on ne remplace rien.
      Le handler vit ICI et pas dans somnair-ob.js parce que somnair-cart.js
      est chargé sur TOUT le store : le bouton marche donc aussi si le client
      rouvre son tiroir depuis une page sommeil avec une gamelle au panier.

   Tout est délégué sur `document` : Shrine repeint le drawer en remplaçant
   l'innerHTML de .drawer__inner (renderContents), donc aucun listener posé sur
   le markup du drawer ne survivrait. Même voie que somnair-ns.js pour l'ATC. */
(function () {
  'use strict';
  if (window.__somnairCartBound) return;
  window.__somnairCartBound = true;

  function route(name, fallback) {
    return (window.routes && window.routes[name]) || fallback;
  }

  /* Mêmes ids de sections que l'ATC de somnair-ns.js (voie éprouvée). */
  function sectionIds(drawer) {
    try {
      if (drawer && typeof drawer.getSectionsToRender === 'function') {
        return drawer.getSectionsToRender().map(function (s) {
          return s.id;
        });
      }
    } catch (e) {
      /* défauts ci-dessous */
    }
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  /* Demande le re-rendu des sections dans la même requête que la mutation. */
  function withSections(payload, drawer) {
    payload.sections = sectionIds(drawer);
    payload.sections_url = window.location.pathname;
    return payload;
  }

  function post(url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(payload)
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (response) {
        if (response.status && response.status !== 200) {
          throw new Error(response.description || response.message || 'cart error');
        }
        return response;
      });
  }

  /* Repeint le drawer. Voie normale = renderContents(response) avec les
     sections renvoyées par la mutation. Mais sur ce store les réponses de
     /cart/add & /cart/change renvoient `sections: null` (constaté en live sur
     toutes les formes de requête), alors que GET /?sections=cart-drawer rend
     bien la section : on retombe donc sur un re-fetch + swap de .drawer__inner,
     exactement ce que fait renderContents. Dernier recours : reload. */
  function paint(drawer, response, freeze) {
    var ghost = freeze ? snapshot() : null;
    var sections = response && response.sections;
    if (drawer && typeof drawer.renderContents === 'function' &&
        sections && typeof sections === 'object' && Object.keys(sections).length) {
      if (typeof drawer.setActiveElement === 'function') {
        drawer.setActiveElement(document.activeElement);
      }
      drawer.classList.toggle('is-empty', response.item_count === 0);
      /* Même réservation de place que dans refresh() : renderContents détruit le
         pied (donc `.smob-cs`), que somnair-ob.js met ~150 ms à reconstruire. */
      var before = document.querySelector('#CartDrawer .drawer__inner');
      var kept = before ? holdFooter(before) : 0;
      drawer.renderContents(response);
      /* renderContents REMPLACE #CartDrawer : le nœud d'avant est détaché. */
      var after = document.querySelector('#CartDrawer .drawer__inner');
      if (after) releaseFooter(after, kept);
      showGhost(ghost);
      return Promise.resolve();
    }
    return refresh(drawer, response).then(function () { showGhost(ghost); },
                                          function (e) { showGhost(ghost); throw e; });
  }

  /* --------------------------------------------------- gel visuel du repaint

     Mesuré au screencast le 2026-08-19 : ~1,5 s après l'ouverture du tiroir, le
     pré-cochage de l'assurance repeint tout, et pendant ~120 ms on voit un état
     INTERMÉDIAIRE — bandeau d'objectif revenu au texte du Liquid, lignes
     « Discounts / Subtotal » disparues, bouton Checkout remonté de 68 px, icônes
     de paiement absentes — avant que somnair-ob.js ne repose le récapitulatif.
     Le client n'a rien demandé à ce moment-là : il lit un tiroir qui clignote.

     La parade est purement visuelle : on pose une PHOTO de l'ancien tiroir
     par-dessus le nouveau, et on la retire en fondu dès que le récapitulatif est
     revenu. Le client voit donc un état cohérent, puis l'autre — jamais l'entre-deux.

     Réservé au pré-cochage automatique. Une mutation DEMANDÉE (quantité,
     cross-sell, décochage) doit répondre tout de suite : y geler l'écran ferait
     exactement l'inverse de ce qu'on cherche. */
  var GHOST_CAP = 900;   /* jamais figé plus longtemps, même si .smob-cs ne revient pas */

  function snapshot() {
    var live = document.querySelector('#CartDrawer .drawer__inner');
    /* Pas de récapitulatif = pas de reconstruction asynchrone à masquer (tiroir
       de la marque sommeil, par exemple) : geler n'apporterait qu'une latence. */
    if (!live || !live.querySelector('.smob-cs')) return null;
    var ghost = document.createElement('div');
    ghost.className = 'smc-ghost';
    ghost.setAttribute('aria-hidden', 'true');
    ghost.innerHTML = live.innerHTML;
    /* Une copie du markup = des id en double et des crochets à handlers. On
       désarme les deux : `getElementById` doit continuer de tomber sur le vrai
       nœud, et un clic ne doit jamais partir d'une photo. */
    var i, nodes = ghost.querySelectorAll('[id], [data-smc-prot], [data-smc-up], [data-smc-xs], [data-smc-swap], [data-smob-cart]');
    for (i = 0; i < nodes.length; i++) {
      nodes[i].removeAttribute('id');
      nodes[i].removeAttribute('data-smc-prot');
      nodes[i].removeAttribute('data-smc-up');
      nodes[i].removeAttribute('data-smc-xs');
      nodes[i].removeAttribute('data-smc-swap');
      nodes[i].removeAttribute('data-smob-cart');
    }
    return ghost;
  }

  function showGhost(ghost) {
    var live = ghost && document.querySelector('#CartDrawer .drawer__inner');
    if (!live) return;
    live.appendChild(ghost);
    var started = Date.now();
    var tick = setInterval(function () {
      var l = document.querySelector('#CartDrawer .drawer__inner');
      if (!l || !l.contains(ghost)) return clearInterval(tick);   /* re-repaint : la photo est partie avec */
      /* La photo contient sa PROPRE copie de `.smob-cs` : sans exclure ses
         descendants on lèverait le gel à la première frame, pour rien. */
      var rebuilt = false, seen = l.querySelectorAll('.smob-cs');
      for (var k = 0; k < seen.length; k++) {
        if (!ghost.contains(seen[k])) { rebuilt = true; break; }
      }
      if (rebuilt || Date.now() - started > GHOST_CAP) {
        clearInterval(tick);
        /* Retrait SEC, pas de fondu : les deux images sont quasi identiques (seuls
           les montants changent), un cross-fade ferait lire deux prix superposés
           pendant 100 ms. Une coupe entre deux états cohérents ne se voit pas. */
        if (ghost.parentNode) ghost.parentNode.removeChild(ghost);
      }
    }, 50);
  }

  /* Le swap de .drawer__inner reconstruit TOUT le tiroir. Deux effets visibles
     qui font passer une mutation réussie pour un bug, et leur parade :

       · le tiroir remonte en haut — on relit et on repose scrollTop ;
       · le récapitulatif .smob-cs du skin chien n'est PAS dans le Liquid : il
         est rebâti par somnair-ob.js, qui doit d'abord aller chercher /cart.js.
         Le pied se retrouve donc vide le temps d'un aller-retour, le tiroir se
         tasse puis se rouvre — le fameux « clignotement ». On ne peut pas
         accélérer sa reconstruction d'ici, mais on peut RÉSERVER SA PLACE :
         min-height figée sur le pied, relâchée dès que le récapitulatif est
         revenu (ou au bout d'1,2 s, pour ne jamais rester coincé trop haut si
         le panier a réellement rétréci). */
  var FOOTER_SEL = '.drawer__footer, .cart-drawer__footer';

  function holdFooter(live) {
    var footer = live.querySelector(FOOTER_SEL);
    if (!footer || !footer.querySelector('.smob-cs')) return 0;
    return footer.getBoundingClientRect().height;
  }

  function releaseFooter(live, held) {
    var footer = held && live.querySelector(FOOTER_SEL);
    if (!footer) return;
    if (footer.querySelector('.smob-cs')) return;   /* rien à masquer */
    footer.style.minHeight = held + 'px';
    var started = Date.now();
    var tick = setInterval(function () {
      var f = live.querySelector(FOOTER_SEL);
      if (!f) return clearInterval(tick);
      if (f.querySelector('.smob-cs') || Date.now() - started > 1200) {
        f.style.minHeight = '';
        clearInterval(tick);
      }
    }, 100);
  }

  function refresh(drawer, response) {
    /* Toujours depuis "/" : sur une URL /products/*, `Accept: application/json`
       renvoie le JSON du produit au lieu des sections. */
    return fetch('/?sections=cart-drawer,cart-icon-bubble', {
      headers: { Accept: 'application/json' }
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        var holder = document.createElement('div');
        holder.innerHTML = data['cart-drawer'] || '';
        var fresh = holder.querySelector('.drawer__inner');
        var live = document.querySelector('#CartDrawer .drawer__inner');
        if (!fresh || !live) throw new Error('drawer introuvable');
        var scroll = live.scrollTop;
        var held = holdFooter(live);
        live.innerHTML = fresh.innerHTML;
        live.scrollTop = scroll;
        releaseFooter(live, held);
        if (drawer && response) {
          drawer.classList.toggle('is-empty', response.item_count === 0);
        }
        if (data['cart-icon-bubble']) {
          var bHolder = document.createElement('div');
          bHolder.innerHTML = data['cart-icon-bubble'];
          var bFresh = bHolder.querySelector('#cart-icon-bubble');
          var bLive = document.getElementById('cart-icon-bubble');
          if (bFresh && bLive) bLive.innerHTML = bFresh.innerHTML;
        }
      });
  }

  /* En cas d'échec on recharge : mieux qu'un drawer qui mentirait sur l'état
     réel du panier (la première requête a peut-être abouti). */
  function fail(control) {
    return function () {
      control.removeAttribute('aria-busy');
      window.location.reload();
    };
  }

  /* ============================================ ÉCHANGE ONE-TIME -> ABONNEMENT

     ⚠ LA CLÉ DE LIGNE RENDUE PAR LE LIQUID NE SURVIT PAS À L'AJOUT.
     Mesuré en direct le 2026-09-24, sur un vrai panier : la ligne one-time du
     Maple Wood Chew s'appelait `53877224046920:3ed17d3c…` ; dès que la MÊME
     variante a été ajoutée en abonnement, cette même ligne s'appelait
     `53877224046920:5eb24bf8…`. Shopify ré-empreinte les lignes d'une variante
     dès qu'il y en a plusieurs (ici la seconde fait en plus basculer le palier
     « MAPLE CHEW 2+ (-10%) », qui entre dans l'empreinte).

     Le `/cart/change` partait donc avec une clé morte et recevait
     400 « no valid id or line parameter ». Ce que voyait le client qui cliquait
     « Subscribe & Save 20% » : la ligne one-time RESTAIT au panier, l'abonnement
     s'ajoutait par-dessus (28,98 $ -> 44,49 $), et `fail()` RECHARGEAIT la page
     — le tiroir se refermait sur un panier plus cher qu'avant le clic.

     Trois règles depuis :
       1. on ne se fie plus à la clé rendue — après l'ajout on RELIT /cart.js et
          on agit PAR NUMÉRO DE LIGNE (`line`), lu dans ce panier-là ;
       2. si le retrait n'aboutit pas, on ANNULE l'ajout : deux lignes du même
          produit, c'est le client qui paie deux fois ce qu'il remplaçait ;
       3. plus jamais de `reload`. L'échange doit se voir DANS le tiroir ; en cas
          d'échec on repeint depuis l'état réel et on écrit une phrase dans la
          boîte à erreurs du tiroir, sans jamais faire sortir le client. */
  var UP_ESSAIS = 3;             /* 1 tentative + 2 reprises (429 anti-bot) */
  /* Le message ne PROMET rien sur l'\u00e9tat du panier : quand /cart/change ET
     /cart/update sont tous deux bloqu\u00e9s, l'annulation de l'ajout ne passe pas
     non plus, et jurer \u00ab votre panier n'a pas chang\u00e9 \u00bb serait faux. Le tiroir
     est repeint sur l'\u00e9tat r\u00e9el juste avant : le client lit la v\u00e9rit\u00e9 \u00e0 l'\u00e9cran,
     la phrase ne fait que la lui d\u00e9signer. */
  var UP_ERR = 'We couldn\u2019t switch that item to a subscription \u2014 ' +
               'please check your cart and try again.';

  function noteErreur(msg) {
    var box = document.getElementById('CartDrawer-CartErrors') ||
              document.getElementById('cart-errors');
    if (box) box.textContent = msg;
  }

  function cartRead() {
    return fetch(route('cart_url', '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        /* 429 anti-bot : la réponse est une PAGE HTML, pas du JSON. Sans ce
           test on part en SyntaxError et on croit avoir lu un panier. */
        if (!r.ok) throw new Error('cart.js ' + r.status);
        return r.json();
      });
  }

  /* Numéro de ligne (1-based) de la ligne visée DANS LE PANIER QU'ON VIENT DE
     LIRE. La clé sert tant qu'elle existe encore ; sinon on retombe sur la
     première ligne de la variante du bon côté (abonnement ou non), qui est
     exactement ce que le bouton proposait d'échanger. */
  function lineOf(cart, key, variantId, abo) {
    var i, it, estAbo, repli = 0;
    for (i = 0; i < cart.items.length; i++) {
      it = cart.items[i];
      estAbo = !!it.selling_plan_allocation;
      if (estAbo !== abo) continue;
      if (key && it.key === key) return i + 1;
      if (!repli && it.variant_id === variantId) repli = i + 1;
    }
    return repli;
  }

  /* Porte une ligne à la quantité que `calc` déduit de la ligne RÉELLE. On relit
     le panier À CHAQUE tentative : entre deux essais il a pu bouger (429, autre
     onglet), et un numéro de ligne périmé toucherait le mauvais produit.
     Résout sur la réponse de /cart/change, ou sur null s'il n'y avait rien à
     faire — dans les deux cas l'appelant repeint. */
  function setLine(drawer, cible, calc, essai) {
    essai = essai || 1;
    return cartRead()
      .then(function (cart) {
        var n = lineOf(cart, cible.key, cible.variantId, cible.abo);
        if (!n) return null;                        /* ligne déjà partie */
        var item = cart.items[n - 1];
        var q = calc(item);
        if (q === item.quantity) return null;
        return post(route('cart_change_url', '/cart/change'),
                    withSections({ line: n, quantity: q }, drawer))
          .catch(function (e) {
            if (essai < UP_ESSAIS) throw e;          /* il reste des reprises */
            /* Dernier recours, sur un AUTRE endpoint. `updates` est la voie que
               le filet cadeaux emprunte déjà quand le storefront s'obstine, et
               elle écrit par CLÉ DE LIGNE — celle qu'on vient de lire, jamais
               celle que le Liquid avait rendue. Ça ne sauve pas un 429 général,
               mais ça sauve une panne propre à /cart/change. */
            var u = {};
            u[item.key] = q;
            return post(route('cart_update_url', '/cart/update') + '.js',
                        withSections({ updates: u }, drawer));
          });
      })
      .catch(function (e) {
        if (essai >= UP_ESSAIS) throw e;
        return attendre(300 * essai).then(function () {
          return setLine(drawer, cible, calc, essai + 1);
        });
      });
  }

  function upgradeToSub(drawer, key, to, qty, plan) {
    var ligne = { id: to, quantity: qty };
    /* Avec selling_plan la ligne ajoutée est un abonnement : même variante que
       la ligne one-time, mais ligne distincte (on retire l'ancienne ensuite). */
    if (plan) ligne.selling_plan = plan;
    var ajout = null;

    function liberer() {
      /* Le repeint a remplacé le bouton : on relibère celui qui est à l'écran. */
      var btn = document.querySelector('[data-smc-up]');
      if (btn) btn.removeAttribute('aria-busy');
    }

    return post(route('cart_add_url', '/cart/add'), { items: [ligne] })
      .then(function (r) {
        ajout = (r && r.items && r.items[0]) || null;
        return setLine(drawer, { key: key, variantId: to, abo: false },
                       function () { return 0; });
      })
      .then(function (response) {
        return paint(drawer, response || null);
      })
      .then(liberer)
      .catch(function () {
        /* Retour à l'état d'avant le clic : on retire de la ligne d'abonnement
           exactement ce qu'on venait d'y mettre. Elle pouvait déjà exister avec
           une quantité voulue par le client — on ne la vide pas à l'aveugle. */
        var annule = ajout
          ? setLine(drawer, { key: ajout.key, variantId: to, abo: true },
                    function (it) { return Math.max(0, it.quantity - qty); })
          : Promise.resolve(null);
        return annule
          .catch(function () { /* le repeint ci-dessous dira la vérité */ })
          .then(function () { return refresh(drawer, null).catch(function () {}); })
          .then(function () {
            noteErreur(UP_ERR);
            liberer();
          });
      });
  }

  /* ============================================ UPGRADE DE PALIER B1G1 -> B2G2

     Même mécanique que upgradeToSub(), mais la variante CHANGE : on ajoute le
     B2G2 (`n` unités), puis on retire `qty` du B1G1 en relisant /cart.js et en
     visant le NUMÉRO DE LIGNE de la variante d'origine. Si le retrait échoue on
     annule l'ajout — deux paliers au panier, c'est le client qui paie deux fois. */
  var SWAP_ERR = 'We couldn’t upgrade your bundle — ' +
                 'please check your cart and try again.';

  function swapTier(drawer, key, from, qty, to, n) {
    var ajout = null;

    function liberer() {
      var btn = document.querySelector('[data-smc-swap]');
      if (btn) btn.removeAttribute('aria-busy');
    }

    return post(route('cart_add_url', '/cart/add'), { items: [{ id: to, quantity: n }] })
      .then(function (r) {
        ajout = (r && r.items && r.items[0]) || null;
        return setLine(drawer, { key: key, variantId: from, abo: false },
                       function (it) { return Math.max(0, it.quantity - qty); });
      })
      .then(function (response) {
        return paint(drawer, response || null);
      })
      .then(liberer)
      .catch(function () {
        var annule = ajout
          ? setLine(drawer, { key: ajout.key, variantId: to, abo: false },
                    function (it) { return Math.max(0, it.quantity - n); })
          : Promise.resolve(null);
        return annule
          .catch(function () { /* le repeint ci-dessous dira la vérité */ })
          .then(function () { return refresh(drawer, null).catch(function () {}); })
          .then(function () {
            noteErreur(SWAP_ERR);
            liberer();
          });
      });
  }

  document.addEventListener('click', function (evt) {
    if (!evt.target || !evt.target.closest) return;
    var drawer = document.querySelector('cart-drawer');

    /* --- 0. upgrade de palier B1G1 -> B2G2 (même modèle) --- */
    var sw = evt.target.closest('[data-smc-swap]');
    if (sw) {
      evt.preventDefault();
      if (sw.getAttribute('aria-busy') === 'true') return;
      var swFrom = parseInt(sw.getAttribute('data-smc-from'), 10);
      var swTo = parseInt(sw.getAttribute('data-smc-to'), 10);
      var swQty = parseInt(sw.getAttribute('data-smc-qty'), 10) || 1;
      var swN = parseInt(sw.getAttribute('data-smc-n'), 10) || 1;
      if (!swFrom || !swTo) return;
      sw.setAttribute('aria-busy', 'true');
      noteErreur('');
      swapTier(drawer, sw.getAttribute('data-smc-key'), swFrom, swQty, swTo, swN);
      return;
    }

    /* --- 1. upgrade One-Time -> Subscribe & Save (même pack) --- */
    var up = evt.target.closest('[data-smc-up]');
    if (up) {
      evt.preventDefault();
      if (up.getAttribute('aria-busy') === 'true') return;
      var to = parseInt(up.getAttribute('data-smc-to'), 10);
      var qty = parseInt(up.getAttribute('data-smc-qty'), 10) || 1;
      var plan = parseInt(up.getAttribute('data-smc-plan'), 10);
      if (!to) return;
      up.setAttribute('aria-busy', 'true');
      noteErreur('');
      upgradeToSub(drawer, up.getAttribute('data-smc-key'), to, qty, plan);
      return;
    }

    /* --- 2. switch Shipping Protection --- */
    var prot = evt.target.closest('[data-smc-prot]');
    if (prot) {
      evt.preventDefault();
      if (prot.getAttribute('aria-busy') === 'true') return;
      var on = prot.getAttribute('aria-checked') === 'true';
      var payload, url;
      if (on) {
        var protKey = prot.getAttribute('data-smc-key');
        if (!protKey) return;
        url = route('cart_change_url', '/cart/change');
        payload = { id: protKey, quantity: 0 };
      } else {
        var protId = parseInt(prot.getAttribute('data-smc-id'), 10);
        if (!protId) return;
        url = route('cart_add_url', '/cart/add');
        payload = { items: [{ id: protId, quantity: 1 }] };
      }
      prot.setAttribute('aria-busy', 'true');
      /* Le choix du client prime sur le pré-cochage. Sans cette mémoire, le
         repaint qui suit un décochage montre une rangée décochée et
         autoProtect() reposerait la ligne dans la seconde : le client verrait
         l'assurance revenir toute seule. Portée onglet (sessionStorage) — une
         visite suivante repropose. Cocher à la main efface le refus. */
      rememberChoice(on);
      /* Flip OPTIMISTE. La bascule doit répondre au doigt, pas au réseau : sans
         ça le switch reste immobile pendant tout l'aller-retour puis saute d'un
         coup une fois le Liquid re-rendu — c'est exactement ce qui se lit comme
         « ça bugue ». L'état serveur reprend la main au repaint qui suit, et il
         dit alors la même chose : le client ne voit qu'une seule animation. */
      prot.setAttribute('aria-checked', on ? 'false' : 'true');
      post(url, withSections(payload, drawer))
        .then(function (response) {
          return paint(drawer, response);
        })
        .catch(function () {
          /* UNE seule requête est partie : si elle échoue, rien n'a bougé au
             panier et on peut revenir en arrière proprement. Pas de reload —
             fail() reste justifié pour [data-smc-up], qui enchaîne DEUX
             requêtes et peut donc laisser un état intermédiaire. */
          prot.setAttribute('aria-checked', on ? 'true' : 'false');
          prot.removeAttribute('aria-busy');
        });
      return;
    }

    /* --- 3. cross-sell Bowl <-> Feeder : ajout du modèle jumeau ---
       La carte disparaît d'elle-même au repaint : son Liquid ne la rend que
       si UN SEUL des deux modèles est au panier. Rien à masquer en JS.
       Sur les pages chien, paint() retombe sur refresh() (ce store renvoie
       `sections: null` sur /cart/add) et remplace .drawer__inner ; le
       récapitulatif .smob-cs du skin chien est alors reconstruit par le
       MutationObserver de somnair-ob.js — même voie que le switch ci-dessus. */
    var xs = evt.target.closest('[data-smc-xs]');
    if (xs) {
      evt.preventDefault();
      if (xs.getAttribute('aria-busy') === 'true') return;
      var xsId = parseInt(xs.getAttribute('data-smc-id'), 10);
      if (!xsId) return;
      xs.setAttribute('aria-busy', 'true');
      post(
        route('cart_add_url', '/cart/add'),
        withSections({ items: [{ id: xsId, quantity: 1 }] }, drawer)
      )
        .then(function (response) {
          return paint(drawer, response);
        })
        .catch(fail(xs));
    }
  });

  /* ======================================================================
     FILET CADEAUX — un cadeau annoncé gratuit ne doit jamais être encaissé

     Le cadeau (« 2 FREE Feeding Mats ») est une VRAIE ligne du vrai produit,
     ramenée à 0 par une remise automatique BXGY. Un prix à 0,00 $ ne peut pas
     échouer, une remise si : palier changé, gamelle retirée du panier, remise
     plafonnée, produit repassé en brouillon. La ligne reste alors au panier à
     49,98 $, avec un bouton Checkout actif juste en dessous.

     ⚠️ Ce recomptage vivait dans somnair-ob.js. Il n'y couvrait que les pages
     qui chargent `somnair-ob-scope` : la home et les pages gamelle. Ni /cart,
     ni les pages légales, ni le blog — c'est-à-dire ni la page où le client
     revoit son panier, ni celles où il finit par cliquer sur Checkout. Il vit
     ici depuis le 27/08, avec le reste du tiroir, donc sur tout le store.

     TROIS ÉCHELONS, du moins cher au plus visible :
       1. planGifts() recompte et rend les corrections à écrire ;
       2. writeGifts() écrit, VÉRIFIE sur la réponse, et RÉESSAIE. Une seule
          tentative ne suffisait pas : le storefront répond 429 « Verifying your
          connection » aux XHR quand l'anti-bot se réveille, alors que les
          navigations, elles, passent. Ce jour-là le client gardait sous les yeux
          un tapis facturé 49,98 $ que la page lui avait promis gratuit, et le
          tiroir affichait le message d'erreur générique du thème (constaté le
          26/08, capture à l'appui) ;
       3. au clic sur Checkout, si une ligne cadeau est encore facturée, la
          correction part dans la MÊME navigation que le checkout (POST /cart,
          le formulaire natif du panier Shopify) — une navigation traverse le
          bouclier anti-bot, un XHR non.
     ====================================================================== */

  /* ---------------------------------------------------- 1. la décision (pure)

     CE QUE LE FOURNISSEUR DOIT LIRE : une quantité qui dit la vérité. Son
     message du 24/08 — « the orders' SKUs are the same, but the displayed
     quantities are different » — portait sur exactement ça : la même ligne
     cadeau partait tantôt à 1, tantôt à 2, sans qu'aucun panier ne le justifie.
     Le stepper est bien masqué (somnair-cart-lock.css), mais masquer n'est pas
     compter : un double clic sur « Add to cart » suivi d'une correction de la
     ligne gamelle laissait le cadeau au double (#1139, #1152), et un cadeau
     survivait même à un changement de palier (#1136 : tapis sur un Buy 1 get 1).

     TROIS RÈGLES, DANS CET ORDRE
     1. Une ligne cadeau encore FACTURÉE est retirée. C'est le filet du passage
        au vrai produit + remise automatique : un prix à 0,00 $ ne pouvait pas
        échouer, une remise si. Mieux vaut pas de cadeau qu'un cadeau payé
        49,98 $ par un client à qui la page l'a promis gratuit.
     2. La quantité due vaut `_gift_units` × le nombre de bundles réellement au
        panier (`_gift_for` = la variante qui ouvre le droit). Zéro bundle, zéro
        cadeau : ça couvre l'ancien cas « cadeau orphelin » (le client retire la
        gamelle) sans avoir à exclure l'assurance colis pré-cochée, qui ne peut
        plus être confondue avec un achat puisqu'on compare des variantes, plus
        des totaux.
     3. Un groupe peut compter PLUSIEURS lignes (propriétés différentes selon
        l'âge de la ligne) : la première porte tout le dû, les autres tombent à
        zéro. Sinon on multiplierait le cadeau par le nombre de lignes.

     Rend `null` quand il n'y a rien à corriger — le cas de tous les paniers
     sains, donc du plus fréquent. Aucun effet de bord, aucune requête : c'est
     ce qui la rend testable hors navigateur (test_normalise_gifts.js). */
  function planGifts(cart) {
    var groupes = {};
    (cart.items || []).forEach(function (it) {
      var p = it.properties || {};
      if (!p._gift_with) return;
      var cle = String(p._gift_for || p._gift_with);
      (groupes[cle] = groupes[cle] || []).push(it);
    });
    var cles = Object.keys(groupes);
    if (!cles.length) return null;

    var updates = {};
    cles.forEach(function (cle) {
      var lignes = groupes[cle];
      var p0 = lignes[0].properties || {};
      var unites = Number(p0._gift_units) || 1;

      /* Les bundles qui ouvrent le droit. Par id de variante quand on l'a
         (`_gift_for`, posé à l'ajout) ; à défaut par titre de variante, pour
         les lignes d'avant le 24/08 qui ne portent que `_gift_with`. */
      var vid = Number(p0._gift_for) || 0;
      var libelle = p0._gift_with;
      var bundles = 0;
      (cart.items || []).forEach(function (it) {
        if (it.properties && it.properties._gift_with) return;   /* jamais un cadeau */
        if (vid ? it.variant_id === vid : it.variant_title === libelle) {
          bundles += it.quantity;
        }
      });
      var du = bundles * unites;

      /* UNE ligne de panier peut ressortir en DEUX entrées de /cart.js quand la
         remise n'en couvre qu'une partie — constaté en direct le 24/08 : la
         gamelle ramenée de 2 à 1 laissait « tapis ×2 à 0 » + « tapis ×2
         facturés 49,98 $ ». Les deux entrées partagent la MÊME clé de ligne :
         on raisonne donc par clé, jamais par entrée, sinon on écrirait deux
         fois dans la même case et la dernière écriture (0) gagnerait. */
      var parCle = {}, ordre = [];
      lignes.forEach(function (it) {
        if (!(it.key in parCle)) { parCle[it.key] = 0; ordre.push(it.key); }
        parCle[it.key] += it.quantity;
      });
      var total = ordre.reduce(function (s, k) { return s + parCle[k]; }, 0);

      if (total !== du) {
        /* La première clé porte tout le dû, les autres tombent à zéro. */
        ordre.forEach(function (k, i) {
          var cible = (i === 0) ? du : 0;
          if (parCle[k] !== cible) updates[k] = cible;
        });
        return;
      }

      /* La quantité est déjà juste ET une part reste facturée : cette fois ce
         n'est pas un excès, c'est la remise qui n'a pas pris. On retire. Le
         client repart sans tapis, jamais avec un tapis facturé 49,98 $ que la
         page lui a promis gratuit. Ordre des deux tests non négociable : le
         tester avant la quantité retirerait le cadeau à chaque excès temporaire,
         alors qu'il suffisait de recompter. */
      if (giftFacture(lignes)) ordre.forEach(function (k) { updates[k] = 0; });
    });

    return Object.keys(updates).length ? updates : null;
  }

  /* Une entrée cadeau qui coûte quelque chose. `final_line_price` est le prix
     APRÈS remises — c'est celui que le checkout encaisserait. */
  function giftFacture(lignes) {
    return lignes.some(function (it) {
      var pf = (typeof it.final_line_price === 'number') ? it.final_line_price : it.line_price;
      return pf > 0;
    });
  }

  /* Y a-t-il, à cet instant, de l'argent en jeu sur une ligne cadeau ? C'est la
     seule question qui autorise la garde du bouton Checkout à intervenir. */
  function giftsFactures(cart) {
    return (cart.items || []).some(function (it) {
      return it.properties && it.properties._gift_with && giftFacture([it]);
    });
  }

  /* --------------------------------------------------------- 2. l'écriture */

  var GIFT_ESSAIS = 3;          /* 1 tentative + 2 reprises, ~2,1 s au total */
  var giftBusy = false;
  var giftLu = 0;               /* dernière lecture de /cart.js (throttle) */
  /* Ce que la garde du checkout aura à rattraper si l'écriture n'aboutit pas. */
  var giftEtat = { plan: null, facture: false };

  function attendre(ms) {
    return new Promise(function (r) { setTimeout(r, ms); });
  }

  function writeGifts(updates, essai, enchaine) {
    return fetch(route('cart_update_url', '/cart/update') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (r) {
        /* 429 anti-bot : la réponse est une PAGE HTML, pas du JSON. Sans ce
           test on partirait en SyntaxError et on croirait avoir écrit. */
        if (!r.ok) throw new Error('cart/update ' + r.status);
        return r.json();
      })
      .then(function (cart) {
        giftLu = Date.now();
        giftEtat.facture = giftsFactures(cart);
        var suite = planGifts(cart);
        giftEtat.plan = suite;
        /* Une correction en appelle parfois une seconde : on RECOMPTE d'abord
           (règle 2), puis on retire ce que la remise n'a pas couvert (règle 1).
           Une seule fois — au-delà ce serait une boucle, et le repeint suivant
           reprendra la main de toute façon. */
        if (suite && !enchaine) return writeGifts(suite, 1, true);
        return repeindre(cart);
      })
      .catch(function (e) {
        if (essai < GIFT_ESSAIS) {
          return attendre(essai * 700).then(function () {
            return writeGifts(updates, essai + 1, enchaine);
          });
        }
        /* Plus rien à tenter en XHR. On ne recharge PAS (un reload sur un 429
           boucle) : le plan reste en mémoire, et la garde du bouton Checkout
           l'écrira par une vraie navigation, au moment où il y a de l'argent en
           jeu. */
        throw e;
      });
  }

  /* L'ecriture a abouti : reste a le MONTRER. Le repeint n'est pas l'ecriture —
     s'il echoue, on ne rejoue surtout pas la correction (elle est faite), sinon
     on partirait en trois ecritures pour un tiroir absent.

     Sur une page sans tiroir — /cart en premier lieu, la ou le client regarde
     justement ses lignes — il n'y a rien a repeindre : on recharge, une fois.
     Le compteur en sessionStorage est le garde-fou, parce qu'un rechargement
     remet a zero toute variable de module : deux rechargements par onglet au
     maximum, apres quoi on laisse le panier tel quel plutot que de boucler. */
  var GIFT_RECHARGES = 'somnair:gift-reload';

  function repeindre(cart) {
    var cd = document.querySelector('cart-drawer');
    if (cd) {
      return refresh(cd, { item_count: cart.item_count }).catch(function () {});
    }
    try {
      var n = Number(sessionStorage.getItem(GIFT_RECHARGES) || '0');
      if (n < 2) {
        sessionStorage.setItem(GIFT_RECHARGES, String(n + 1));
        window.location.reload();
      }
    } catch (e) { /* stockage refuse : on s'abstient, le panier est deja corrige */ }
    return null;
  }

  /* Rend une promesse si une correction est partie — le repeint suivant
     reprendra l'habillage —, null s'il n'y avait rien à corriger. C'est le
     contrat qu'attend buildSummary() dans somnair-ob.js. */
  function runGifts(cart) {
    if (!cart || !cart.items) return null;
    giftLu = Date.now();
    giftEtat.facture = giftsFactures(cart);
    var updates = planGifts(cart);
    giftEtat.plan = updates;
    if (!updates || giftBusy) return null;
    giftBusy = true;
    return writeGifts(updates, 1, false)
      .catch(function () { /* échec silencieux : cf. la garde du checkout */ })
      .then(function () { giftBusy = false; });
  }

  /* Une lecture de /cart.js, au plus une toutes les 3 s. Sur les pages gamelle
     buildSummary() nous appelle déjà avec le panier qu'il vient de lire : le
     compteur `giftLu` est commun, on ne double donc aucune requête. */
  function giftGuard(force) {
    if (giftBusy) return;
    var now = Date.now();
    if (!force && now - giftLu < 3000) return;
    giftLu = now;
    fetch(route('cart_url', '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('cart.js ' + r.status);
        return r.json();
      })
      .then(function (cart) { runGifts(cart); })
      .catch(function () { /* bouclier ou réseau : le dernier état connu tient */ });
  }

  /* ------------------------------------------- 3. la garde du bouton Checkout

     Le thème signale toute mutation ratée par un message générique — « There was
     an error while updating your cart. Please try again. » — et s'arrête là. Le
     tiroir garde alors à l'écran un état qui n'est plus celui du panier, et le
     bouton Checkout, lui, marche : c'est une vraie navigation, il traverse le
     bouclier que les XHR n'ont pas traversé. Le client paierait le cadeau.

     On envoie donc le formulaire natif du panier : POST /cart avec les
     `updates[clé]` de la correction ET le champ `checkout`. Shopify corrige le
     panier puis redirige vers le checkout, en une seule navigation. */
  function formCorrection(plan) {
    var f = document.createElement('form');
    f.method = 'post';
    f.action = route('cart_url', '/cart');
    f.style.display = 'none';
    Object.keys(plan).forEach(function (cle) {
      var i = document.createElement('input');
      i.type = 'hidden';
      i.name = 'updates[' + cle + ']';
      i.value = String(plan[cle]);
      f.appendChild(i);
    });
    var c = document.createElement('input');
    c.type = 'hidden';
    c.name = 'checkout';
    c.value = 'Checkout';
    f.appendChild(c);
    return f;
  }

  /* En capture : le thème écoute le clic sur ce bouton, on doit passer avant
     lui. Une seule condition d'intervention — de l'argent en jeu sur une ligne
     cadeau ET un plan pour le corriger. Sinon on ne touche à rien : aucune vente
     ne doit jamais être bloquée par ce fichier. */
  document.addEventListener('click', function (evt) {
    if (!evt.target || !evt.target.closest) return;
    var btn = evt.target.closest('[name="checkout"], .cart__checkout-button');
    if (!btn || !giftEtat.facture || !giftEtat.plan) return;
    var f;
    try {
      f = formCorrection(giftEtat.plan);
    } catch (e) {
      return;                     /* on laisse partir le checkout tel quel */
    }
    evt.preventDefault();
    evt.stopPropagation();
    giftEtat.plan = null;         /* la garde ne se redéclenchera pas */
    try {
      document.body.appendChild(f);
      f.submit();
    } catch (e2) {
      btn.click();                /* plan vidé : ce clic-ci passe normalement */
    }
  }, true);

  /* Le thème émet `cartQuantityUpdated` dans son bloc `finally` : l'événement
     part MÊME quand la mutation a échoué. C'est notre seul signal dans ce cas —
     on repart de l'état RÉEL du panier plutôt que de laisser le tiroir mentir.
     Si le repeint échoue à son tour, le message d'erreur reste affiché : c'est
     la vérité, le client doit réessayer. */
  document.addEventListener('cartQuantityUpdated', function () {
    var box = document.getElementById('CartDrawer-CartErrors') ||
              document.getElementById('cart-errors');
    var casse = !!(box && box.textContent.trim());
    giftGuard(casse);
    if (!casse) return;
    refresh(document.querySelector('cart-drawer')).catch(function () {});
  });

  /* somnair-ob.js (pages gamelle) nous passe le panier qu'il vient de lire. */
  window.somnairGifts = { plan: planGifts, run: runGifts, guard: giftGuard };

  /* ======================================================================
     PRÉ-COCHAGE (12/08, retiré le 16/08, rétabli le 18/08, désarmé le 15/10,
     RÉARMÉ le 20/10 par PROT_PRECHECK = true — demande de Zeid, risque UK/FTC
     ci-dessous assumé explicitement, pas de garde géographique posée)
     + GARDE « protection orpheline »

     autoProtect() : la protection part COCHÉE. La rangée .smc-prot est du
     Liquid rendu côté serveur — elle n'existe que si le panier contient autre
     chose que la protection, et son `aria-checked` dit l'état RÉEL du panier.
     Elle est donc son propre signal : rangée présente + décochée ⇒ on pose la
     ligne. Aucun réglage, aucun attribut de plus à rendre — `settings_data.json`
     ne bouge pas.

     ⚖️ Une case pré-cochée qui ajoute un frais est illicite au UK (Consumer
     Contracts Regulations 2013, reg. 40 : le consentement à tout paiement
     supplémentaire doit être exprès) et attaquable côté US (FTC, negative
     option). Le store vend US/CA/UK/AU. Choix assumé par l'utilisateur : posé
     le 12/08, retiré le 16/08, redemandé le 18/08. Pour le désarmer sur le seul
     marché UK il suffirait d'un `if (window.Shopify && Shopify.country === 'GB')
     return;` en tête d'autoProtect().

     Quatre garde-fous, un par panne possible :
       · mémoire de refus (sessionStorage) : sinon le repaint qui suit un
         décochage relance l'ajout et l'assurance revient toute seule ;
       · `autoAdded`, UNE pose par chargement : /cart/add incrémente, un
         `aria-checked` périmé donnerait quantity: 2 ;
       · échec SILENCIEUX, jamais fail() : le storefront répond 429 « Verifying
         your connection » à un XHR quand l'anti-bot se réveille, et un reload
         sur cet échec boucle à l'infini ;
       · confirmAlone() relit /cart.js avant tout vidage (ci-dessous).

     La garde orpheline, elle, est INDÉPENDANTE du réglage par défaut — le
     client peut aussi cocher lui-même : il prend la protection, puis retire la
     gamelle. Le panier ne vaut plus que 3,99 $ d'assurance, avec un bouton
     Checkout actif. On le vide — mais le DOM ne
     fait que SOUPÇONNER (la ligne porte `cart-item--product-<handle>`, cf.
     snippets/cart-drawer.liquid) ; c'est /cart.js qui tranche, parce qu'un DOM
     à mi-rendu ne doit jamais pouvoir vider un vrai panier.

     Échec SILENCIEUX. Surtout pas le reload de fail() : le storefront répond
     429 « Verifying your connection » à un XHR quand l'anti-bot se réveille, et
     un reload sur cet échec boucle à l'infini. On se contente d'annuler.

     Déclenchement par MutationObserver, parce que le tiroir est aussi repeint
     par le thème lui-même (ATC natif depuis la PDP), chemin que nos handlers ne
     voient pas.

     ⚠️ L'observateur est posé sur document.body, PAS sur #CartDrawer comme
     watchDrawer() dans somnair-ob.js. Mesuré le 12/08 sur le live : au repaint
     Shrine ne mute pas #CartDrawer, il le REMPLACE (l'ancien nœud ressort
     isConnected=false et l'observateur qui y était accroché voit 0 mutation —
     c'est exactement pourquoi la première version ne se déclenchait jamais).
     body, lui, ne bouge jamais. Coût tenu par le debounce + les sorties
     immédiates ci-dessous.

     La boucle se termine d'elle-même : après le vidage il n'y a plus de ligne.
     ==================================================================== */

  var PROT_HANDLE = 'somnair-shipping-protection';
  var PROT_OPTOUT = 'somnair:prot-optout';
  /* RÉARMÉ le 20/10 (demande de Zeid) après un passage décoché du 15/10 au
     20/10 : la rangée repart cochée par défaut, opt-out au client, garde-fous
     inchangés. Risque UK (Consumer Contracts Regulations 2013, reg. 40) et
     FTC negative-option assumé explicitement, sans garde géographique. */
  var PROT_PRECHECK = true;
  var autoBusy = false;
  /* Une seule pose automatique par chargement de page : /cart/add INCRÉMENTE,
     et les repaints arrivent en salve avec des `aria-checked` d'un instant
     antérieur — sans ce verrou on facturerait deux assurances. */
  var autoAdded = false;
  /* Un soupçon d'orphelin ne coûte qu'UN /cart.js : sans ce verrou, une page qui
     mute en continu (carrousel, widget) le redemanderait toutes les 150 ms et
     réveillerait l'anti-bot du store pour rien. Remis à zéro dès que le DOM
     cesse de ressembler à un panier d'assurance seule. */
  var aloneChecked = false;

  /* Le refus du client, mémorisé pour l'onglet. sessionStorage peut lever
     (mode privé Safari, cookies bloqués) : on dégrade en « pas de refus »
     plutôt que de casser le tiroir. */
  function optedOut() {
    try {
      return sessionStorage.getItem(PROT_OPTOUT) === '1';
    } catch (e) {
      return false;
    }
  }

  /* wasOn = l'état AVANT le clic : true ⇒ le client vient de décocher. */
  function rememberChoice(wasOn) {
    try {
      if (wasOn) sessionStorage.setItem(PROT_OPTOUT, '1');
      else sessionStorage.removeItem(PROT_OPTOUT);
    } catch (e) {
      /* stockage indisponible : le pré-cochage sera juste reproposé au repaint */
    }
  }

  /* Rangée visible et décochée ⇒ on pose la ligne à la place du client. */
  function autoProtect() {
    if (!PROT_PRECHECK || autoBusy || autoAdded || optedOut()) return;
    var scope = document.getElementById('CartDrawer');
    if (!scope) return;
    var row = scope.querySelector('[data-smc-prot]');
    if (!row) return;                          /* panier vide, ou protection seule */
    if (row.getAttribute('aria-checked') === 'true') return;
    var protId = parseInt(row.getAttribute('data-smc-id'), 10);
    if (!protId) return;   /* produit dépublié : échec muet du 12/08, on n'insiste pas */

    var drawer = document.querySelector('cart-drawer');
    autoAdded = true;
    autoBusy = true;
    /* Flip optimiste, comme au clic : sans lui la rangée reste décochée le
       temps de l'aller-retour, ce qui se lit comme un switch qui bascule tout
       seul une seconde plus tard. */
    row.setAttribute('aria-checked', 'true');
    post(
      route('cart_add_url', '/cart/add'),
      withSections({ items: [{ id: protId, quantity: 1 }] }, drawer)
    )
      .then(function (response) {
        /* `true` = gel visuel : ce repaint-ci n'a été demandé par personne, il
           tombe pile pendant que le client découvre son tiroir. */
        return paint(drawer, response, true);
      })
      .catch(function () {
        /* Silencieux : surtout pas de reload (429 anti-bot = boucle infinie).
           On repose l'état visible sur celui du panier réel et on n'y revient
           pas de ce chargement — `autoAdded` reste à true. */
        try {
          row.setAttribute('aria-checked', 'false');
        } catch (e) {}
      })
      .then(function () {
        autoBusy = false;
      });
  }

  /* Le tiroir semble ne contenir QUE de la protection ? Simple SOUPÇON : le DOM
     peut être à mi-rendu, et vider un vrai panier là-dessus serait la pire
     régression possible. La décision se prend sur /cart.js (cf. confirmAlone). */
  function looksAlone(scope) {
    var prot = scope.querySelectorAll('.cart-item--product-' + PROT_HANDLE);
    if (!prot.length) return false;
    return scope.querySelectorAll('.cart-item').length === prot.length;
  }

  /* Le serveur tranche : on ne vide que si le panier réel ne contient rien
     d'autre que de la protection. Une requête, uniquement dans ce cas rare. */
  function confirmAlone() {
    return fetch(route('cart_url', '/cart') + '.js', {
      headers: { Accept: 'application/json' }
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        if (!cart || !cart.items || !cart.items.length) return false;
        for (var i = 0; i < cart.items.length; i++) {
          if (cart.items[i].handle !== PROT_HANDLE) return false;
        }
        return true;
      });
  }

  function cartGuard() {
    if (autoBusy) return;
    var scope = document.getElementById('CartDrawer');
    if (!scope) return;
    var drawer = document.querySelector('cart-drawer');

    /* protection seule au panier -> on vide */
    if (!looksAlone(scope)) {
      aloneChecked = false;   /* le DOM a changé d'avis : on pourra re-vérifier */
      return;
    }
    if (aloneChecked) return;  /* un seul /cart.js par soupçon, pas un par salve */
    aloneChecked = true;
    autoBusy = true;
    confirmAlone()
      .then(function (alone) {
        if (!alone) return null;
        return post(route('cart_clear_url', '/cart/clear'), withSections({}, drawer))
          .then(function (response) {
            return paint(drawer, response);
          });
      })
      .catch(function () {})
      .then(function () {
        autoBusy = false;
      });
  }

  /* ------------------------------------- confettis « Free shipping unlocked! »

     Une petite gerbe qui sort de la barre d'objectif quand le client ouvre un
     tiroir dont la livraison vient d'être débloquée. Une fois par PASSAGE du
     seuil, pas à chaque ouverture : l'état vu en dernier est mémorisé pour
     l'onglet (sessionStorage), on ne tire que sur un « pas débloqué -> débloqué »
     (ou au premier tiroir débloqué de la session).

     Le signal est la barre elle-même, remplie à 100 % — jamais un seuil écrit
     ici : sur les pages gamelle elle est recalculée par goalBar() (somnair-ob.js)
     dans la devise du marché, ailleurs c'est le rendu du thème. Les confettis
     disent donc toujours la même chose que la barre. Sur les pages gamelle on
     attend que .smob-cs soit revenu : avant, la barre porte encore le calcul du
     thème (80 $), pas celui de la boutique.

     La gerbe vit dans <body>, en position fixe, PAS dans le tiroir : le repeint
     remplace .drawer__inner et l'emporterait en plein vol. */
  var FX_KEY = 'smc:ship-unlocked';
  var fxTimer = null;

  function shipBar() {
    var cd = document.querySelector('cart-drawer');
    if (!cd || !cd.classList.contains('active') || cd.classList.contains('is-empty') ||
        cd.classList.contains('smob-loading')) return null;
    if (document.getElementById('smob-cart-summary') && !cd.querySelector('#CartDrawer .smob-cs')) return null;
    var bars = cd.querySelectorAll('#CartDrawer .cart-progress__bar');
    for (var i = 0; i < bars.length; i++) {
      if (bars[i].closest('.smc-ghost')) continue;
      var r = bars[i].getBoundingClientRect();
      if (r.width > 0 && r.height > 0) return bars[i];   /* masquée (pages cd/dt) = rien */
    }
    return null;
  }

  function burst(bar) {
    var r = bar.getBoundingClientRect();
    var layer = document.createElement('div');
    layer.className = 'smc-confetti';
    layer.setAttribute('aria-hidden', 'true');
    document.body.appendChild(layer);
    var colors = ['#1ca14a', '#2E5693', '#1b3854', '#f2b632', '#7fd19b'];
    for (var i = 0; i < 26; i++) {
      var p = document.createElement('i');
      var w = 5 + Math.random() * 3;
      var round = Math.random() < 0.3;
      p.style.cssText = 'left:' + (r.left + Math.random() * r.width) + 'px;top:' + (r.top + r.height / 2) +
        'px;width:' + w + 'px;height:' + (round ? w : w * 0.45) + 'px;background:' +
        colors[i % colors.length] + (round ? ';border-radius:50%' : '');
      layer.appendChild(p);
      /* Petit saut seulement : sur mobile la barre est à ~40 px du haut de
         l'écran, une gerbe qui monte haut sortirait du cadre. Elle s'écarte
         puis retombe sur le tiroir. */
      var dx = (Math.random() - 0.5) * 160;
      var up = Math.min(12 + Math.random() * 30, r.top - 4);
      var down = 110 + Math.random() * 150;
      var rot = (Math.random() - 0.5) * 720;
      p.animate([
        { transform: 'translate(0,0) rotate(0deg)', opacity: 1, easing: 'cubic-bezier(.15,.7,.35,1)' },
        { transform: 'translate(' + dx * 0.6 + 'px,' + -up + 'px) rotate(' + rot * 0.4 + 'deg)', opacity: 1, offset: 0.35, easing: 'cubic-bezier(.45,0,.85,.55)' },
        { transform: 'translate(' + dx + 'px,' + down + 'px) rotate(' + rot + 'deg)', opacity: 0 }
      ], { duration: 1300 + Math.random() * 500, delay: Math.random() * 120, fill: 'both' });
    }
    setTimeout(function () {
      if (layer.parentNode) layer.parentNode.removeChild(layer);
    }, 2100);
  }

  function shipCheck() {
    fxTimer = null;
    var bar = shipBar();
    if (!bar) return;   /* tiroir fermé ou pas encore stable : on ne note rien */
    var fill = bar.firstElementChild;
    var on = !!fill && parseFloat(fill.style.width) >= 100;
    var prev = null;
    try { prev = sessionStorage.getItem(FX_KEY); } catch (e) { /* stockage bloqué : on tire au pire une fois de trop */ }
    try { sessionStorage.setItem(FX_KEY, on ? '1' : '0'); } catch (e) {}
    if (!on || prev === '1') return;
    if (!document.body.animate) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    burst(bar);
  }

  function watchShip() {
    if (typeof MutationObserver === 'undefined') return;
    /* Ouverture = classe `active` posée sur <cart-drawer> (qui survit au
       repeint) ; repeint = enfants remplacés sous lui. 450 ms après le premier
       signal, sans repousser : le glissement d'ouverture (300 ms) est fini. */
    new MutationObserver(function (list) {
      if (fxTimer) return;
      for (var i = 0; i < list.length; i++) {
        var t = list[i].target;
        if (t.nodeType !== 1) continue;
        if (t.tagName === 'CART-DRAWER' || (t.closest && t.closest('cart-drawer'))) {
          fxTimer = setTimeout(shipCheck, 450);
          return;
        }
      }
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
  }

  /* Ordre : on vide AVANT de poser. Un panier d'assurance seule ne rend pas la
     rangée (Liquid), donc autoProtect() n'y touche pas de toute façon — mais
     l'ordre inverse ferait dépendre le résultat du timing. */
  function tick() {
    cartGuard();
    autoProtect();
    /* Le filet cadeaux, sur TOUTE page qui affiche un panier non vide : au
       chargement d'abord (une ligne cadeau facturee peut dormir dans un panier
       vieux d'hier), puis a chaque salve de repeints. Le coût est tenu par le
       throttle de giftGuard — une lecture de /cart.js toutes les 3 s au plus,
       compteur partagé avec buildSummary() qui, sur les pages gamelle, nous
       passe déjà le panier qu'il vient de lire. */
    if (document.querySelector('.cart-item')) giftGuard(false);
  }

  function watchGuard() {
    if (!document.body) {   /* chargé en <head> : on attend le body à observer */
      document.addEventListener('DOMContentLoaded', watchGuard);
      return;
    }
    tick();
    watchShip();
    if (typeof MutationObserver === 'undefined') return;
    var pending = null;
    /* Seules les mutations du PANIER relancent tick() (19/10). Mesuré sur la PDP
       gamelle avec un article au panier : compte à rebours, citations et bandeau
       mutent le DOM chaque seconde -> tick() -> giftGuard() -> un GET /cart.js
       toutes les ~4 s, tiroir ouvert OU fermé, sans fin (4 requêtes en 15 s).
       Le repeint du tiroir (Shrine : #CartDrawer, somnair-ob : <cart-drawer>,
       refresh() : .drawer__inner) et la page /cart (<cart-items>) passent tous ici. */
    function cartish(list) {
      for (var i = 0; i < list.length; i++) {
        var t = list[i].target;
        var el = t && t.nodeType === 1 ? t : t && t.parentNode;
        if (el && el.closest && el.closest('cart-drawer, cart-items, #cart-icon-bubble')) return true;
      }
      return false;
    }
    var mo = new MutationObserver(function (list) {
      if (autoBusy || pending || !cartish(list)) return;
      pending = setTimeout(function () {
        pending = null;
        tick();
      }, 150);   /* le repaint arrive par lots : une seule passe par salve */
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchGuard);
  } else {
    watchGuard();
  }

  /* ================================= OUVERTURE IMMÉDIATE — formulaires Shrine natifs (19/10)

     Mesuré le 19/10 sur la PDP corgi (CPU ×4, trace Chrome) : le tiroir ne
     commence à glisser que 1 045 ms après le tap — aller-retour /cart/add avec
     sections (~480 ms serveur), puis renderContents et le travail des pixels —,
     et 4 des 9 premières frames du glissement sont perdues parce qu'il démarre
     pile pendant ce travail. Sur la PDP gamelle, somnair-ob.js ouvre AVANT le
     réseau : glissement à 250 ms, 15 frames sur 15. Même recette ici, pour tout
     <product-form> natif (bouton principal ET sticky ATC) : on ouvre au tap
     avec le squelette `smob-loading` (somnair-cart.css §8), et le contenu réel
     arrive en fondu `smc-in` quand Shrine le pose.

     Garde-fous :
       · bouton désactivé (variante épuisée, envoi en cours) -> on n'ouvre pas ;
       · le message d'erreur du formulaire apparaît (422, rupture) -> on referme ;
       · le bouton a fini de tourner (finally de main.js) sans que rien ne soit
         posé -> échec réseau : on referme 400 ms après (mesuré : requête coupée,
         sans ce garde le squelette restait 8 s) ;
       · rien n'est revenu au bout de 8 s (429 anti-bot, réseau) -> on referme ;
       · renderContents n'écrase jamais .drawer__inner PENDANT le glissement
         (le nouveau panneau naîtrait à translateX(0) : saut en fin de course) ;
       · on l'appelle en mode silencieux quand on a déjà ouvert : son open()
         différé poserait un écouteur `transitionend` qui piégerait le focus à
         la FERMETURE suivante ; le piège est posé ici, tout de suite. */
  (function () {
    var CD = window.customElements && customElements.get('cart-drawer');
    if (!CD || CD.prototype.__smnOptimistic) return;
    CD.prototype.__smnOptimistic = true;
    var openedAt = 0, seq = 0;
    var render = CD.prototype.renderContents;
    CD.prototype.renderContents = function (response, silent) {
      var self = this;
      if (!self.classList.contains('smob-loading') || !openedAt) {
        return render.call(self, response, silent);
      }
      var run = function () {
        render.call(self, response, true);
        openedAt = 0;
        self.classList.remove('smob-loading', 'smc-in');
        void self.offsetWidth;            /* relance l'animation d'entrée */
        self.classList.add('smc-in');
        setTimeout(function () { self.classList.remove('smc-in'); }, 420);
        try {
          if (typeof trapFocus === 'function') {
            trapFocus(document.getElementById('CartDrawer') || self, self.querySelector('.drawer__inner'));
          }
        } catch (e) { /* accessibilité : jamais bloquant */ }
      };
      var wait = 320 - (Date.now() - openedAt);
      if (wait > 0) setTimeout(run, wait); else run();
    };

    function optimistic(form, trigger) {
      /* Pas de garde `.smob-scope` : la classe existe AUSSI sur la corgi (header,
         bandeau et pied « ob »). Les pages gamelle n'ont aucun <product-form> :
         leur formulaire est celui de somnair-ob.js, elles ne passent jamais ici. */
      var cd = document.querySelector('cart-drawer');
      var btn = form.querySelector('[type="submit"]');
      if (!cd || !btn || btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
      if (cd.classList.contains('active')) return;
      cd.classList.remove('is-empty');
      cd.classList.add('animate', 'active', 'smob-loading');
      document.body.classList.add('overflow-hidden');
      openedAt = Date.now();
      var token = ++seq, done = false;
      var close = function () {
        if (done || token !== seq) return;      /* minuteur d'une ouverture précédente */
        done = true;
        openedAt = 0;
        if (!cd.classList.contains('smob-loading')) return;   /* le contenu est arrivé entre-temps */
        cd.classList.remove('smob-loading');
        if (typeof cd.close === 'function') cd.close();
        else { cd.classList.remove('active'); document.body.classList.remove('overflow-hidden'); }
      };
      var pf = form.closest('product-form');
      var err = pf && pf.querySelector('.product-form__error-message-wrapper');
      if (err && window.MutationObserver) {
        var mo = new MutationObserver(function () {
          if (!err.hasAttribute('hidden')) { mo.disconnect(); close(); }
        });
        mo.observe(err, { attributes: true, attributeFilter: ['hidden'] });
        setTimeout(function () { mo.disconnect(); }, 8000);
      }
      /* main.js pose `loading` sur le bouton CLIQUÉ (sticky ou principal) et le
         retire dans son finally, succès comme échec. */
      var spin = trigger || btn, sawLoading = false;
      if (window.MutationObserver) {
        var bmo = new MutationObserver(function () {
          if (spin.classList.contains('loading')) { sawLoading = true; return; }
          if (!sawLoading) return;
          bmo.disconnect();
          setTimeout(close, 400);
        });
        bmo.observe(spin, { attributes: true, attributeFilter: ['class'] });
        setTimeout(function () { bmo.disconnect(); }, 8000);
      }
      setTimeout(close, 8000);
    }

    document.addEventListener('submit', function (evt) {
      var f = evt.target;
      if (!f || !f.closest || !f.closest('product-form')) return;
      if (f.closest('[data-is-cart-upsell="true"], cart-drawer')) return;
      optimistic(f, evt.submitter);
    }, true);
    /* Sticky ATC : bouton type=button qui appelle productForm.handleSubmit()
       sans événement submit (layout/theme.liquid, script « SectionAtcBtn- »). */
    document.addEventListener('click', function (evt) {
      var b = evt.target && evt.target.closest && evt.target.closest('[id^="SectionAtcBtn-"]');
      if (!b) return;
      var f = b.form || document.getElementById(b.getAttribute('form'));
      if (f) optimistic(f, b);
    }, true);
  })();
})();

/* ================================== PANIER VIDE -> FICHE PRODUIT (24/10/2026)
   Demande de Zeid : « fais en sorte que le panier [...] ne bug jamais avec les clients,
   quand il est vide il les renvoie sur la PDP direct ».

   Mesuré le 24/10 (iPhone émulé, live) : vidé, le tiroir n'offrait qu'une impasse — son
   bouton « Continue shopping » menait à /collections/all, page BLANCHE sous ce thème (clé
   de licence Shrine absente, cf. mémoire perf), et /cart (lien « retour au panier » du
   checkout) l'était aussi. Désormais :
     · chaque fiche produit visitée est retenue (localStorage `smn:last-pdp`) ;
     · tiroir vide : le bouton mène à cette fiche (repli : la gamelle, best-seller) ;
     · sur une fiche, le panier qu'on vient de vider se referme : le client y est déjà ;
     · ailleurs, l'icône panier d'un panier vide emmène directement sur la fiche ;
     · /cart redirige vers la fiche — tiroir ouvert s'il reste des articles ;
     · Échap ferme le tiroir même quand le focus n'y est pas (Shrine n'écoute que dedans) ;
     · un tiroir vide s'affiche toujours « Your cart is empty », jamais en panneau blanc.
   Aucun appel réseau sauf sur /cart (un /cart.js). Toute erreur retombe sur le
   comportement d'avant : jamais de blocage du tiroir. */
(function () {
  var CLE = 'smn:last-pdp';
  var REPLI = '/products/somnair-elevated-dog-bowl';
  var p = location.pathname;
  var chemin = p.replace(/^\/[a-z]{2}(-[a-z]{2})?(?=\/)/i, '');      // sans préfixe de langue (/es/…)
  var prefixe = p.slice(0, p.length - chemin.length);
  var surFiche = /^\/products\/[^/]+\/?$/.test(chemin);

  function lire() { try { return localStorage.getItem(CLE) || ''; } catch (e) { return ''; } }
  function cible() { return lire() || (prefixe + REPLI); }
  if (surFiche) { try { localStorage.setItem(CLE, p); } catch (e) { /* navigation privée */ } }

  /* /cart : page blanche sous ce thème -> la fiche, tiroir ouvert s'il reste des articles. */
  if (/^\/cart\/?$/.test(chemin)) {
    var part = function (plein) { location.replace(cible() + (plein ? '#panier' : '')); };
    try {
      fetch('/cart.js', { cache: 'no-store', credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (c) { part(c && c.item_count > 0); }, function () { part(false); });
    } catch (e) { part(false); }
    return;
  }

  function tiroir() { return document.querySelector('cart-drawer'); }
  function estVide(cd) { return !!cd && (cd.classList.contains('is-empty') || !!cd.querySelector('.drawer__inner-empty')) && !cd.querySelector('.cart-item'); }

  /* Le bouton du tiroir vide mène à la fiche, à chaque rendu du tiroir. */
  function lien() {
    var cd = tiroir();
    if (!cd) return;
    cd.querySelectorAll('.drawer__inner-empty a.button, .drawer__inner-empty a[href*="/collections"]').forEach(function (a) {
      if (a.getAttribute('href') !== cible()) a.setAttribute('href', cible());
    });
  }

  /* somnair-ob.js retire `is-empty` à chaque ouverture par l'icône : panier vide, le
     tiroir s'affichait en panneau blanc + « Checkout • $0.00 » grisé (mesuré le 24/10
     sur la fiche gamelle). On la remet avant le rendu ; jamais pendant un ajout
     (`smob-loading` : la coquille doit rester ouverte). */
  function recale(cd) {
    if (!cd.classList.contains('is-empty') && !cd.classList.contains('smob-loading') &&
        cd.querySelector('.drawer__inner-empty') && !cd.querySelector('.cart-item')) cd.classList.add('is-empty');
  }

  function prete() {
    var cd = tiroir();
    if (!cd) return;
    lien();
    recale(cd);
    var avait = !estVide(cd), minuteur = null;
    if (window.MutationObserver) {
      new MutationObserver(function () {
        recale(cd);
        lien();
        var vide = estVide(cd);
        /* Sur la fiche, le panier qu'on vient de vider se referme : le client y est déjà. */
        if (surFiche && vide && avait && cd.classList.contains('active') && !minuteur) {
          minuteur = setTimeout(function () {
            minuteur = null;
            if (estVide(cd) && cd.classList.contains('active') && typeof cd.close === 'function') cd.close();
          }, 700);
        }
        avait = !vide;
      }).observe(cd, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    }
    /* Retour de /cart avec des articles : on ouvre le tiroir. */
    if (location.hash === '#panier') {
      try { history.replaceState(null, '', location.pathname + location.search); } catch (e) {}
      setTimeout(function () {
        var b = document.querySelector('[data-smob-cart]');
        if (b) b.click(); else if (typeof cd.open === 'function') cd.open();
      }, 400);
    }
  }

  /* Hors fiche, l'icône panier d'un panier vide emmène directement sur la fiche. Capture :
     passe avant somnair-ob.js / le repli du header, qui ouvriraient un tiroir vide. */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    /* Sur cette fiche même, le bouton du tiroir vide referme le tiroir : recharger
       la page qu'on a sous les yeux ne servirait à rien. */
    var a = t.closest('.drawer__inner-empty a[href]');
    if (a) {
      var cd = tiroir();
      if (a.pathname === location.pathname && cd && typeof cd.close === 'function') { e.preventDefault(); cd.close(); }
      return;
    }
    var b = t.closest('[data-smob-cart]');
    if (!b || surFiche) return;
    if (!estVide(tiroir())) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    location.href = cible();
  }, true);

  /* Échap ferme le tiroir quel que soit le focus. */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var cd = tiroir();
    if (cd && cd.classList.contains('active') && typeof cd.close === 'function') cd.close();
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prete);
  else prete();
})();
